import React from "react";
import { Link } from "react-router-dom";
import PageHeader from "@/components/layout/PageHeader";

const SECTIONS = [
  {
    title: "Custodians",
    description:
      "Custodians will report to Lincoln Professional Development Center 8:30am-12 noon to participate in a morning of professional learning designed for Custodians.",
    sessions: [
      {
        title: "Self-Care, Stress Management, & Time Management",
        description: `This course will help custodians explore practical strategies for managing stress, balancing daily responsibilities, and maintaining personal well-being. Participants will learn simple self-care techniques that can be used before, during, and after the workday. The session will also provide time management tips to help custodians stay organized, focused, and productive. Overall, this course is designed to support custodians in caring for themselves while continuing to provide excellent service to schools and students.`,
      },
      {
        title: "Campus Safety Through the Lens of a Custodian",
        description: `This course will help custodians understand their important role in maintaining a safe and secure campus environment. Participants will learn how to identify potential safety concerns, report hazards, and respond appropriately to situations they may observe during their daily work. The session will also highlight how custodians support school safety through awareness, communication, and attention to detail. Overall, this course is designed to strengthen campus safety by empowering custodians to serve as active partners in protecting students, staff, and visitors.`,
      },
      {
        title: "Chemical Use & Safety, Equipment Operation, & Effective Cleaning Practices",
        description: `This course will provide custodians with important guidance on the proper use, handling, and storage of cleaning chemicals. Participants will review safety procedures, including reading labels, using personal protective equipment, and following district guidelines to prevent accidents or exposure. The session will also cover safe equipment operation and effective cleaning practices that support healthy school environments. Overall, this course is designed to help custodians work safely, efficiently, and consistently while maintaining clean and well-kept facilities.`,
      },
      {
        title: "Department Updates",
        description: `This session will provide custodians with important department updates, reminders, and expectations for the upcoming school year. Participants will receive information to support consistency, communication, and continued excellence across all school and district facilities.`,
      },
    ],
  },
  {
    title: "Librarians",
    description:
      "Librarians should select a grade level they serve and participate in the professional development activities assigned to that group of teachers. Librarians will not have a separate professional development session.",
  },
];

function sortByTitle(arr) {
  return [...arr].sort((a, b) =>
    a.title.localeCompare(b.title, undefined, { sensitivity: "base" })
  );
}

export default function OtherStaff() {
  const sorted = sortByTitle(SECTIONS);

  return (
    <div className="space-y-6 pb-12" data-testid="other-staff-page">
      <PageHeader title="Other Staff" barColor="#145261" />

      {sorted.map((section) => (
        <div
          key={section.title}
          className="bg-card rounded-xl border border-border p-4"
          data-testid={`other-staff-section-${section.title.toLowerCase()}`}
        >
          <h2 className="font-semibold text-base text-foreground mb-3">
            {section.title}
          </h2>

          {section.description ? (
            <p className="text-sm text-muted-foreground leading-relaxed">
              {section.description}
            </p>
          ) : !section.sessions ? (
            <p className="text-sm text-muted-foreground font-bold">
              Information coming soon.
            </p>
          ) : null}

          {section.sessions && section.sessions.length > 0 && (
            <div className="mt-4">
              <h3 className="font-semibold text-base text-foreground mb-3">
                Sessions and Descriptions
              </h3>
              <div className="space-y-5" data-testid="other-staff-sessions">
                {sortByTitle(section.sessions).map((s, i) => (
                  <div
                    key={i}
                    className="border-t border-border pt-4"
                    data-testid="other-staff-session-item"
                  >
                    <h3 className="font-semibold text-base text-foreground mb-2">
                      {s.title}
                    </h3>
                    <div className="text-sm text-muted-foreground leading-relaxed whitespace-pre-line">
                      {s.description}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      ))}

      <div className="pt-2">
        <Link
          to="/resources"
          className="inline-flex items-center gap-2 text-base font-semibold text-primary underline hover:opacity-80"
          data-testid="resources-page-link"
        >
          Resources
        </Link>
      </div>
    </div>
  );
}
